/**
 * AdminLayout Component
 *
 * Layout wrapper for admin section pages:
 * - Admin sidebar navigation
 * - Main content area with Outlet
 * - Capability-based navigation visibility
 */

import type { ReactElement } from "react";
import { Outlet } from "react-router-dom";

import { AdminSidebar } from "./AdminSidebar";

export function AdminLayout(): ReactElement {
  return (
    <div className="flex flex-1 overflow-hidden">
      {/* Admin Sidebar */}
      <AdminSidebar />

      {/* Admin Content Area */}
      <div className="flex flex-1 flex-col overflow-hidden bg-background">
        <Outlet />
      </div>
    </div>
  );
}

export default AdminLayout;
